import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loading from "../../components/loading/Loading";
import All from "./All";
import Create from "./Create";
import Update from "./Update";

const DiscountCoupon = () => {
  const [component, setComponent] = useState(<Loading />);
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname.split("/");
    switch (pathname[2]) {
      case "create":
        setComponent(<Create />);
        break;
      case "update":
        setComponent(<Update id={pathname[3]} />);
        break;
      default:
        setComponent(<All />);
    }
  }, [location]);

  return component;
};

export default DiscountCoupon;
